export const contactsData = {
    email: 'dindafirlyamalia@gmail.com',
    phone: '(+62) 82 331 111 164',
    address: 'JL. Girilaya IX no. 14. Surabaya',

    sheetAPI: ''
}